module.exports = __webpack_public_path__ + "static/parade-2020-house29-6127e1a4317a5d6a47f940d94a54da42.jpg";